import React from 'react';

export default class Header extends React.Component {
	constructor(props) {
		super(props);

		this.handleUpdateSortOrder = this.handleUpdateSortOrder.bind(this);
	}

	render() {
		return (
			<div
				className="Header"
				onClick={
					this.props.column.isSortable == false ? null : this.props.column
						.apiName ? (
						this.handleUpdateSortOrder
					) : (
						''
					)
				}
			>
				<span className="Header-value">{this.props.column.displayName}</span>
				<span className="Header-sortIcon">{this.renderSortOrderIcon()}</span>
			</div>
		);
	}

	renderSortOrderIcon() {
		if (this.props.column.isSortable === false) {
			return '';
		} else if (this.props.column.apiName) {
			let { sortColumn, sortOrder } = this.props;

			if (sortColumn !== this.props.column.apiName) {
				return <i className="fas fa-sort" />;
			} else {
				if (sortOrder === 'asc') {
					return <i className="fas fa-sort-up" />;
				} else if (sortOrder === 'desc') {
					return <i className="fas fa-sort-down" />;
				} else if (sortOrder !== 'asc' || sortOrder !== 'desc') {
					return <i className="fas fa-sort" />;
				}
			}
		}
	}

	handleUpdateSortOrder(e) {
		// console.log(
		// 	'Current sort order / sort column:',
		// 	this.props.sortOrder,
		// 	this.props.sortColumn
		// );

		this.props.onChangeSortOrder(
			this.props.column.apiName,
			this.props.sortOrder
		);
	}
}
